<template>
  <div class="poster-list">
    <div class="page-actions">
      <el-table :data="poserlist">
        <el-table-column prop="posterType" label="时间">
          <template slot-scope="scope">{{
            scope.row.createTime | moment
          }}</template>
        </el-table-column>
        <el-table-column prop="channelName" label="渠道"> </el-table-column>
        <el-table-column prop="channelAccount" label="账号"></el-table-column>
        <el-table-column prop="orCodeUrl" label="二维码">
          <template slot-scope="scope">
            <img :src="scope.row.orCodeUrl" class="imglist" />
          </template>
        </el-table-column>
        <el-table-column prop="iconUrl" label="图标">
          <template slot-scope="scope">
            <img :src="scope.row.iconUrl" class="imglist" />
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="primary"
              icon="el-icon-edit"
              circle
              size="small"
              @click="handleEdit(scope.row)"
            ></el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              circle
              size="small"
              @click="handleRemove(scope.row.id)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <update-list :onePoster="chooseOne" @refresh="refreshList" />
  </div>
</template>
<script>
import Upload from 'components/upload';
import { mapActions, mapState, mapMutations } from 'vuex';
import updateList from '../update';

export default {
  data() {
    return {
      chooseOne: {},
      pager: {
        page: 1,
        size: 5
      }
    };
  },
  computed: {
    ...mapState('community', ['poserlist', 'totalCount'])
  },
  methods: {
    ...mapActions('community', ['list', 'remove']),
    ...mapMutations('community', ['setupdatePosterDialog']),
    handleEdit(item) {
      this.chooseOne = item;
      this.setupdatePosterDialog(true);
    },
    handleRemove(id) {
      this.$confirm('确认要删除该社区吗？', '提示', { type: 'warning' }).then(
        () => {
          this.remove({ id: id, status: 1 }).then(() => {
            this.$message.success('删除成功！');
            this.$emit('refresh');
          });
        }
      );
    },
    refreshList() {
      this.list({ ...this.pager });
    }
  },
  mounted() {},
  components: {
    updateList
  }
};
</script>
<style lang="less">
.imglist {
  max-height: 100px;
}
</style>
